import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';
import {
  VentaRapidaUserSearchResponse,
} from 'src/app/models/venta-rapida/venta-rapida-user.model';

@Injectable({ providedIn: 'root' })
export class VentaRapidaUserSearchService {
  private readonly baseUrl = `${environment.api_server}/api/v2/assign-products/users/search`;

  constructor(
    private readonly http: HttpClient,
    private readonly _api: ApiService,
  ) {}

  search(eventId: string, query: string): Observable<VentaRapidaUserSearchResponse> {
    const params = new HttpParams()
      .set('q', query)
      .set('event_id', eventId);

    return from(this._api.getAuthHeaders()).pipe(
      switchMap((headers) =>
        this.http.get<VentaRapidaUserSearchResponse>(this.baseUrl, { headers, params })
      )
    );
  }
}
